<template>
  <VPopup
    :target="target"
    :visible="true"
    position="bottom"
    padding="10px"
    :offset="5"
    show-pointer
    :css-classes="['supply-offer-status-popup']"
  >
    <VSelectV2
      ref="statusInput"
      v-model="localSupplyOffer.status"
      label="Статус"
      :data="statusesSource"
      required
      @update:modelValue="saveStatus"
    />
    <br>
    <VSelectV2
      ref="statusAvailability"
      v-model="localSupplyOffer.statusAvailability"
      label="Статус доступности"
      :data="statusesAvailabilitySource"
      required
      @update:modelValue="saveStatusAvailability"
    />
  </VPopup>
</template>

<style lang="scss">
.supply-offer-status-popup {
  width: 200px;
}
</style>

<script lang="ts">

import type SupplyOffer    from '@/domains/SupplyOffers/SupplyOffer';
import SupplyOffersService from '@/domains/SupplyOffers/SupplyOffersService';
import Core                from '@/core/Core';

export default defineComponent({
  name: 'SupplyOfferStatusPopup',

  props: {
    supplyOffer: {
      type:    Object as PropType<SupplyOffer>,
      default: null,
    },
    /** Якорь для VPopup. Не передан — попап рисуется от левой верхнего угла контекстного меню, или фолбек - от курсора. */
    target: {
      type:    HTMLElement,
      default: null,
    },
  },

  data() {
    return {
      localSupplyOffer: Core.utils.cloneDeep(this.supplyOffer),

      statusesSource: this.$core.loader.select(SupplyOffersService.getStatuses()),

      statusesAvailabilitySource: this.$core.loader.select(SupplyOffersService.getStatusesAvailability()),
    };
  },

  methods: {
    async saveStatus(status) {
      if (!status) {
        return;
      }

      this.localSupplyOffer.status = status;

      const success = await SupplyOffersService.update(this.localSupplyOffer);

      if (success) {
        this.$core.dialogs.SupplyOfferStatusPopup.resolve();
      }
    },

    async saveStatusAvailability(statusAvailability) {
      if (!statusAvailability) {
        return;
      }

      this.localSupplyOffer.statusAvailability = statusAvailability;

      const success = await SupplyOffersService.update(this.localSupplyOffer);

      if (success) {
        this.$core.dialogs.SupplyOfferStatusPopup.resolve();
      }
    },
  },
});
</script>
